import { useState, useEffect } from "react";
import { Button } from 'antd'

const ToggleButton = ({ status, statusHandler, id, loading = false }) => {
  const [ toggle, setToggle ] = useState(status)
  const [ originalStatus, setOriginalStatus ] = useState(status)
  
  // Update local state when parent status changes
  useEffect(() => {
    setToggle(status)
    setOriginalStatus(status)
  }, [status])
  
  const handleToggleChange = () => {
    if (loading) return // Prevent multiple clicks during API call
    
    const newStatus = !toggle
    setToggle(newStatus) // Optimistic update
    
    // Call the status handler with success and error callbacks
    statusHandler(id, newStatus, {
      onSuccess: () => {
        // Update the original status to the new successful state
        setOriginalStatus(newStatus)
      },
      onError: () => {
        // Revert to original status on error
        setToggle(originalStatus)
      }
    })
  } 
 
  return (
    <>
      <label className="flex cursor-pointer select-none items-center" onClick={handleToggleChange}>
        { toggle ? 
        <Button className="border-none text-primary" loading={loading}>Active</Button> 
        : <Button danger className="border-none" loading={loading}>Inactive</Button> }
      </label>
    </>
  );
};

export default ToggleButton;
